import React from "react";
import { FaSpinner } from "react-icons/fa";

const LoadingSpinner = (props) => {
  const { isLoading } = props;

  return (
    <>
      {isLoading && (
        <>
          <div className="fixed top-0 bottom-0 left-0 right-0 flex justify-center bg-black opacity-45 z-30"></div>
          <div className="fixed top-1/3 flex justify-center w-full text-5xl z-40">
            <FaSpinner className="text-snappily-green animate-spin" />
          </div>
        </>
      )}
    </>
  );
};

export default LoadingSpinner;
